import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const hubitat = defineConnector({
  identifier: "hubitat",
  name: "Hubitat",
  tagLine: "Local-first home automation hub",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: ({ makerApiUrl }) =>
    urlToPattern(makerApiUrl || "https://cloud.hubitat.com"),
  auth: (app) =>
    queryAuth([{ name: "access_token", value: app.secret.accessToken }]),
  steps: [
    {
      title: "Enable the Maker API",
      items: [
        {
          kind: "markdown",
          content:
            "In your Hubitat hub, add the “Maker API” app, select the devices you want to expose, and copy its access token and the app’s base URL (everything up to and including the app id, e.g. https://cloud.hubitat.com/api/…/apps/34).",
        },
      ],
    },
    {
      title: "Enter your Maker API details",
      items: [
        {
          kind: "baseUrl",
          label: "Maker API base URL",
          placeholder: "http://192.168.1.10/apps/api/34",
          required: true,
          helperText: "The Maker API URL up to and including the app id.",
          target: { kind: "configuration", field: "makerApiUrl" },
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ makerApiUrl }) => `${makerApiUrl}/devices`,
  },
});
